export default {
    computed: {
        isProposalAccepted() {
            return this.proposal && this.proposal.accepted_at !== null;
        },
        isProposalCompleted() {
            return this.proposal && this.proposal.is_complete;
        },
    },
}